<template>
  <div class="checkout-cart__item">
    <div class="image-product">
      <div class="header-product" style="padding-left: 10px;">
        <div class="header-product-right">
        </div>
<!--        <div class="header-product-left">-->
        <div class="header-product-checkout-cart-item-left">
          <div v-if="modelValue.is_sale" class="sale-product">
            <div class="sale-product-text">
              <div class="sale-product-text-1">
                <span>-{{ modelValue.sum_sale }}%</span>
              </div>
              <div class="sale-product-text-2">
                <span>למוצר שני</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img :src="modelValue.image_main" alt="">
    </div>
    <div class="checkout-cart__item-info">
      <a :href="modelValue.url" class="headline-sm">{{ modelValue.name }}</a>
      <div class="text">{{ modelValue.options_text }}</div>
      <div v-for="opt in modelValue.options" :key="opt" class="text" v-html="opt"></div>
      <div style="direction: ltr; text-align: right;" class="text cart-info-price">₪{{ modelValue.price }} x {{ modelValue.quantity }}</div>
      <div class="checkout-cart__item-info__price">
<!--        <template v-if="modelValue.is_sale">-->
<!--          ₪{{ modelValue.line_price * modelValue.quantity - (modelValue.price * (modelValue.sum_sale/100))}}-->
<!--        </template>-->
<!--        <template v-else>-->
<!--          ₪{{ modelValue.line_price * modelValue.quantity}}-->
<!--        </template>-->
        <div v-if="(modelValue.line_price * modelValue.quantity) != ((modelValue.line_price * modelValue.quantity) - modelValue.productDiscount)">
          <div class="ne-headline-sm">
            ₪{{ (modelValue.line_price * modelValue.quantity) }}
          </div>
        </div>
        ₪{{ (modelValue.line_price * modelValue.quantity) - modelValue.productDiscount}}
      </div>
    </div>
    <div class="checkout-cart__item-delete" @click="removeCartItem(modelValue)">
      <svg width="25" height="30" viewBox="0 0 25 30" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.0312 3.75H16.875V2.8125C16.875 1.2617 15.6133 0 14.0625 0H10.3125C8.7617 0 7.5 1.2617 7.5 2.8125V3.75H2.34375C1.05141 3.75 0 4.80141 0 6.09375V9.375C0 9.89273 0.419766 10.3125 0.9375 10.3125H1.44984L2.25979 27.3213C2.33133 28.8234 3.56531 30 5.06906 30H19.3059C20.8097 30 22.0437 28.8234 22.1152 27.3213L22.9252 10.3125H23.4375C23.9552 10.3125 24.375 9.89273 24.375 9.375V6.09375C24.375 4.80141 23.3236 3.75 22.0312 3.75ZM9.375 2.8125C9.375 2.29559 9.79559 1.875 10.3125 1.875H14.0625C14.5794 1.875 15 2.29559 15 2.8125V3.75H9.375V2.8125ZM1.875 6.09375C1.875 5.83529 2.08529 5.625 2.34375 5.625H22.0312C22.2897 5.625 22.5 5.83529 22.5 6.09375V8.4375C22.2111 8.4375 3.07225 8.4375 1.875 8.4375V6.09375ZM20.2423 27.2321C20.2185 27.7328 19.8071 28.125 19.3059 28.125H5.06906C4.56779 28.125 4.15646 27.7328 4.13268 27.2321L3.32695 10.3125H21.048L20.2423 27.2321Z"
            fill="black"/>
        <path
            d="M12.1875 26.25C12.7052 26.25 13.125 25.8302 13.125 25.3125V13.125C13.125 12.6073 12.7052 12.1875 12.1875 12.1875C11.6698 12.1875 11.25 12.6073 11.25 13.125V25.3125C11.25 25.8302 11.6697 26.25 12.1875 26.25Z"
            fill="black"/>
        <path
            d="M16.875 26.25C17.3927 26.25 17.8125 25.8302 17.8125 25.3125V13.125C17.8125 12.6073 17.3927 12.1875 16.875 12.1875C16.3573 12.1875 15.9375 12.6073 15.9375 13.125V25.3125C15.9375 25.8302 16.3572 26.25 16.875 26.25Z"
            fill="black"/>
        <path
            d="M7.5 26.25C8.01773 26.25 8.4375 25.8302 8.4375 25.3125V13.125C8.4375 12.6073 8.01773 12.1875 7.5 12.1875C6.98227 12.1875 6.5625 12.6073 6.5625 13.125V25.3125C6.5625 25.8302 6.98221 26.25 7.5 26.25Z"
            fill="black"/>
      </svg>
    </div>
    <div class="checkout-cart__item-quantity">
      <div class="checkout-cart__item-quantity-minus" @click="updateCartQuantity(modelValue, -1)">-</div>
      <input type="number" readonly :value="modelValue.quantity" max="99">
      <div class="checkout-cart__item-quantity-plus" @click="updateCartQuantity(modelValue, 1)">+</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckoutCartItem",
  props: {
    modelValue: Object
  },
  methods: {
    updateCartQuantity(item, quantity) {
      this.$emit('update', {item, quantity})
    },
    removeCartItem(item) {
      this.$emit('remove', {item})
    }
  }
}
</script>

<style scoped>
.checkout-cart__item-info__price {
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-end;
}

.ne-headline-sm {
  font-size: 18px;
  line-height: 1;
  color: #888888;
  right: 5%;
  text-decoration: line-through;
  font-weight: 400;
}
</style>
